module.exports = __webpack_public_path__ + "static/phone-c1e583420187bce9d759a191846a86c6.gif";